<template>
  <div class="main">
    <b-tabs
      v-model="tabIndex"
      style="width: 100%"
    >
      <b-tab @click="callSellable">
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t("ProductsInStock") }}</strong>
        </template>
        <div style="display: flex;gap:10px;padding-top: 20px">
          <ProductsInStock @articleNumber="theArticleNumber" />
          <ProductsInStockLocations
            :article-name="articleName"
          />
        </div>
      </b-tab>
      <b-tab @click="inStock">
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t("Recycle") }}</strong>
        </template>
        <div style="display: flex;gap:10px;padding-top: 10px">
          <ProductsInRecycle />
        </div>
      </b-tab>
      <b-tab @click="callSellable">
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t("InternalMoving") }}</strong>
        </template>
        <div style="display: flex;gap:10px;padding-top: 20px">
          <ProductsInStockInternal @articleNumber="theArticleNumber" />
          <ProductsInStockLocationsInternal
            :article-name="articleName"
          />
        </div>
      </b-tab>
      <b-tab @click="callSellable">
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t("ProductsInStockOrder") }}</strong>
        </template>
        <div style="display: flex;gap:10px;padding-top: 20px">
          <ProductsInStockOrder
            :article-list="articleList"
            @resetAllArticles="resetAllArticless"
            @articleNumber="theArticleNumber"
          />
          <ProductsInStockLocationsOrder
            :articleList="articleList"
            :article-name="articleName"
            @addToOrder="addToOrders"
          />
        </div>
      </b-tab>
    </b-tabs>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ProductsInStock from '@/components/productsInStock/ProductsInStock.vue'
import ProductsInStockLocations from '@/components/productsInStock/ProductsInStockLocations.vue'
import ProductsInStockInternal from '@/components/productsInStock/ProductsInStockInternal.vue'
import ProductsInStockLocationsInternal from '@/components/productsInStock/ProductsInStockLocationsInternal.vue'
import ProductsInStockLocationsOrder from '@/components/productsInStock/ProductsInStockLocationsOrder.vue'
import ProductsInRecycle from '@/components/productsInStock/ProductsInRecycle.vue'
import ProductsInStockOrder from '@/components/productsInStock/ProductInStockOrder.vue'

export default {
  components: {
    ProductsInStock,
    ProductsInStockLocations,
    ProductsInRecycle,
    ProductsInStockInternal,
    ProductsInStockLocationsInternal,
    ProductsInStockOrder,
    ProductsInStockLocationsOrder,
  },
  data() {
    return {
      tabIndex: null,
      articleName: null,
      articleList: [],
    }
  },
  methods: {
    ...mapActions(['loadProductInStockList', 'resetTotalStockGroupedByLocationDedication', 'resetTotalStockGroupedByLocation', 'sellableProducts']),
    callSellable() {
      this.sellableProducts({
        pageNumber: 1,
        pageSize: 15,
      })
      this.resetTotalStockGroupedByLocation()
      this.resetTotalStockGroupedByLocationDedication()
    },
    theArticleNumber(value) {
      this.articleName = value
    },
    inStock() {
      this.loadProductInStockList({
        articleNumber: null,
        state: 'Recycle',
        pageNumber: 1,
        pageSize: 15,
      })
    },
    addToOrders(value) {
      const existingArticleIndex = this.articleList.findIndex(
        (item) => { return item.articleNumber === value.articleNumber && item.locationId === value.locationId },
      );
      if (existingArticleIndex !== -1) {
        this.articleList[existingArticleIndex].quantity += value.quantity;
      } else {
        this.articleList.push({
          ...value,
        });
      }
    },
    resetAllArticless() {
      this.articleList = []
    },
  },
}

</script>

<style>
.main {
  display: flex;
  gap: 10px;
}
</style>
